import { render, staticRenderFns } from "./ProductConsultDetail.vue?vue&type=template&id=5e2c50fa&"
import script from "./ProductConsultDetail.vue?vue&type=script&lang=ts&"
export * from "./ProductConsultDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports